var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.797 4.41C17.605.6 23.781.6 27.59 4.41c3.809 3.808 3.809 9.983 0 13.792-3.81 3.81-9.985 3.81-13.793 0-3.809-3.809-3.809-9.984 0-13.793zM28.688 3.31c-4.415-4.415-11.574-4.415-15.99 0-3.924 3.925-4.36 10.017-1.307 14.423l-1.609 1.609a2.991 2.991 0 00-2.24.875L.877 26.881a3 3 0 004.24 4.24l6.664-6.662a2.994 2.994 0 00.875-2.242l1.608-1.607c4.407 3.051 10.498 2.615 14.423-1.31 4.415-4.415 4.415-11.573 0-15.989zM12.093 20.585l.953-.951a13.107 13.107 0 01-.68-.68l-.952.952a3.06 3.06 0 01.68.679zm17.592-9.311a.776.776 0 10-1.553 0 7.471 7.471 0 01-7.47 7.47.777.777 0 000 1.553 9.023 9.023 0 009.023-9.023zM8.638 21.317a1.446 1.446 0 112.046 2.044L4.02 30.024a1.447 1.447 0 01-2.045-2.045l6.662-6.662z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.f3cd58abb0d5a8c221e0f7d8bcd94c85.svg";
export { ForwardRef as ReactComponent };